import React from 'react';
import PropTypes from 'prop-types';

import { PAUSE_MODAL } from '../../containers/modal/modal-types';

import PauseIcon from './assets/pause-icon.svg?react';

import IconButton from '../icon-button';

const PauseButton = ({ disabled, showModal }) => {
    return (
        <IconButton size="medium" type="tertiary" disabled={disabled} svgProps={{ size: 20 }} onClick={() => showModal(PAUSE_MODAL)}>
            <PauseIcon />
        </IconButton>
    );
};

PauseButton.propTypes = {
    disabled: PropTypes.bool,
    showModal: PropTypes.func,
};

export default PauseButton;
